import type { User } from "@shared/context/AuthContext";

type UserIdentityShape = Pick<
  User,
  | "display_name"
  | "title_prefix"
  | "first_name"
  | "last_name"
  | "user_name"
  | "email"
  | "is_service_account"
>;

function normalizeOptionalString(value: unknown): string | null {
  if (typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : null;
}

export function getUserDisplayName(
  user: UserIdentityShape | null | undefined,
): string {
  if (!user) {
    return "User";
  }

  const explicitDisplayName = normalizeOptionalString(user.display_name);
  if (explicitDisplayName) {
    return explicitDisplayName;
  }

  const fullName = [
    normalizeOptionalString(user.title_prefix),
    normalizeOptionalString(user.first_name),
    normalizeOptionalString(user.last_name),
  ]
    .filter((part): part is string => Boolean(part))
    .join(" ")
    .trim();

  if (fullName) {
    return fullName;
  }

  const userName = normalizeOptionalString(user.user_name);
  if (user.is_service_account && userName) {
    return userName;
  }

  const emailLocalPart = normalizeOptionalString(user.email)?.split("@")[0]?.trim();
  return userName || emailLocalPart || "User";
}